import { type GetTenantFeatureConfigurationType, useFetchTenantFeatureConfiguration } from '@repo/config-services';
import { type TenantFeatureConfigurationFeatureName } from '@repo/utils';

const IS_ENABLED_CONFIG_KEY = 'enabled';

export function useTenantFeatureConfigValue(featureName: TenantFeatureConfigurationFeatureName, configKey: string)
  : number | string | boolean | Record<string, unknown> {
  const {
    tenantFeatureConfiguration,
  } = useFetchTenantFeatureConfiguration();

  const configValue = tenantFeatureConfiguration?.tenantFeatureConfiguration?.find(
    (feature) => feature.featureName === featureName && feature.configKey === configKey,
  )?.configValue ?? null;

  return configValue as number | string | boolean | Record<string, unknown>;
}

export function useIsTenantFeatureEnabled(featureName: TenantFeatureConfigurationFeatureName): boolean {
  return Boolean(useTenantFeatureConfigValue(featureName, IS_ENABLED_CONFIG_KEY));
}

export function useTenantFeatureConfig(featureName: TenantFeatureConfigurationFeatureName, configKey: string): {
  tenantFeatureConfiguration: GetTenantFeatureConfigurationType | null;
  configValue: number | string | boolean | Record<string, unknown> | null;
  isLoading: boolean;
} {
  const {
    tenantFeatureConfiguration,
    isLoading,
  } = useFetchTenantFeatureConfiguration();

  const configValue = tenantFeatureConfiguration?.tenantFeatureConfiguration?.find(
    (feature) => feature.featureName === featureName && feature.configKey === configKey,
  )?.configValue ?? null;

  return {
    tenantFeatureConfiguration,
    configValue,
    isLoading: isLoading ?? false,
  };
}
